/**
 * SECTION — GLOBAL NAV
 *
 * - Switches .foot-menu between light/dark themes based on the section
 *   currently behind the foot bar (sections opt in via data-foot-theme).
 * - Manages the drawer: open/close with slide (class-based .is-open),
 *   focus trap + return, ESC and backdrop dismiss, scroll lock, link auto-close.
 */
(function () {
  'use strict';

  // ─── Theme detection by scroll position ─────────────────────────────────
  function initFootTheme(menu) {
    // Server-forced theme (e.g. policy pages): leave the strip class untouched.
    if (menu.hasAttribute('data-foot-theme-lock')) return;

    var sections = document.querySelectorAll('[data-foot-theme]');
    if (!sections.length) return;

    var ticking = false;

    function compute() {
      var y = window.innerHeight - 60;
      var active = 'light';
      for (var i = 0; i < sections.length; i++) {
        var r = sections[i].getBoundingClientRect();
        if (r.top < y && r.bottom > y) active = sections[i].dataset.footTheme;
      }
      menu.classList.toggle('dark', active === 'dark');
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(compute);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    compute();
  }

  // ─── Drawer (slide-in panel) ────────────────────────────────────────────
  function initOverlay(trigger, overlay) {
    if (!trigger || !overlay) return;

    var closeBtn = overlay.querySelector('[data-foot-menu-close]');
    var panel = overlay.querySelector('.full-menu-panel');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var previousFocus = null;

    function open() {
      previousFocus = document.activeElement;
      overlay.hidden = false;
      // Force reflow so the closed state applies before the slide-in transition.
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstFocusable = overlay.querySelector('a, button');
      if (firstFocusable) firstFocusable.focus();
    }

    function close() {
      overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
      // Hide after the slide-out (or immediately if motion is reduced).
      if (reduceMotion || !panel) {
        overlay.hidden = true;
      } else {
        panel.addEventListener('transitionend', function handler(e) {
          if (e.propertyName !== 'transform') return;
          panel.removeEventListener('transitionend', handler);
          if (!overlay.classList.contains('is-open')) overlay.hidden = true;
        });
      }
    }

    trigger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Click on backdrop closes; click on inner content does not.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    // ESC closes when overlay is visible.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.hidden === false) close();
    });

    // Focus trap: keep Tab within the drawer while open (modal behaviour).
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || overlay.hidden) return;
      var focusables = overlay.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Clicking a link auto-closes (single-page anchors keep UX consistent).
    overlay.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', close);
    });
  }

  // ─── Ready ──────────────────────────────────────────────────────────────
  function init() {
    var menu    = document.querySelector('.foot-menu');
    var trigger = document.querySelector('[data-foot-menu-trigger]');
    var overlay = document.querySelector('[data-foot-menu-overlay]');

    if (menu) {
      initFootTheme(menu);
      // Intro animation safety net: pin the visible state after the slide-up so
      // the bar can never stay hidden (setTimeout fires even in background tabs).
      setTimeout(function () { menu.classList.add('foot-shown'); }, 1400);
    }
    if (trigger) initOverlay(trigger, overlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
